import {z} from "zod";

import {zUrlArray, zUrlIsoDate, zUrlNumber} from "../../../../../../shared/utils/zod-url";

export const userTasksSearchSchema = z.object({
  page: zUrlNumber(z.coerce.number().min(1).optional()).catch(1),
  perPage: zUrlNumber(z.coerce.number().min(1).optional()).catch(10),
  q: z.string().optional().catch(undefined),
  sortBy: z.enum(["id", "title", "status", "dueAt"]).optional().catch(undefined),
  sortDir: z.enum(["asc", "desc"]).optional().catch(undefined),
  statuses: zUrlArray(z.array(z.enum(["pending", "in-progress", "completed"])).optional()),
  dueDateStart: zUrlIsoDate(z.iso.date().optional()),
  dueDateEnd: zUrlIsoDate(z.iso.date().optional()),
});

export type UserTasksSearch = z.infer<typeof userTasksSearchSchema>;
